/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    videoTag : [],
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.GetVideoTagAction.REQUEST_GETVIDEOTAG:
      return {
        ...state,
    };
    case actions.GetVideoTagAction.GETVIDEOTAG_RECEIVED:
          return{
      ...state,
      videoTag : action.data.videoTag,
    };

    default:
      return state;
  }
};

export default reducer;
